import { APPLICATION_TYPES } from '@/constants/applications'
import { TApplication } from '@/interfaces'
import { ApplicationsState, ConvocatoriasState } from '@/state'
import { useComputed } from '@preact/signals-react'
import { useState } from 'react'
import { Button } from 'antd'

const RPA_URL = 'http://localhost:8000/rpa'

export default function CurrentApplicationDetailsInfo() {
  const currentApplicationTypeLabel = APPLICATION_TYPES.find(
    (item) => item.value === ApplicationsState.currentApplicationType.value
  )?.label

  const convocatoriaName = useComputed<string>(() => {
    const nameFromConvocatoriaState =
      ConvocatoriasState.currentConvocatoria?.value?.name
    const nameFromApplication =
      typeof ApplicationsState.currentApplication.value?.CConvocatoria === 'object' &&
      ApplicationsState.currentApplication.value?.CConvocatoria !== null &&
      'name' in ApplicationsState.currentApplication.value?.CConvocatoria
        ? (ApplicationsState.currentApplication.value?.CConvocatoria as { name?: string }).name
        : undefined
    return nameFromConvocatoriaState || nameFromApplication || ''
  })

  const [loadingRPA, setLoadingRPA] = useState(false)

  // Extract cedulas from CPostulante and CNucleoFamiliar
  function extractCedulas(appData: any): string[] {
    const cedulas: string[] = []

    // 1. Main applicant cedula (CPostulante.documento)
    if (
      appData?.CPostulante?.documento &&
      typeof appData.CPostulante.documento === 'string'
    ) {
      cedulas.push(appData.CPostulante.documento)
    }

    // 2. Nucleo Familiar cedulas (CNucleoFamiliar[].docNumber)
    if (Array.isArray(appData?.CNucleoFamiliar)) {
      appData.CNucleoFamiliar.forEach((member: any) => {
        if (member?.docNumber && typeof member.docNumber === 'string') {
          cedulas.push(member.docNumber)
        }
      })
    }

    // 3. Deduplicate and return
    return Array.from(new Set(cedulas))
  }

  const handleConsultarRPA = async () => {
    setLoadingRPA(true)
    const appData = ApplicationsState.currentApplication.value
    const cedulas = extractCedulas(appData)
    console.log('Cedulas to send to RPA:', cedulas)
    try {
      const response = await fetch(RPA_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', accept: 'application/json' },
        body: JSON.stringify({ cedulas, force_async: false, systems: ['vur', 'catastro', 'mi_vivienda'] }),
      })
      const result = await response.json()
      // Optionally, show a notification or handle result
      console.log('RPA result:', result)
    } catch (error) {
      console.error('Error calling RPA endpoint:', error)
    } finally {
      setLoadingRPA(false)
    }
  }

  return (
    <div className='details-info'>
      <div className='detail-option'>
        <div className='detail-label'>CONVOCATORIA</div>
        <div className='detail-value'>{convocatoriaName.value}</div>
      </div>
      <div className='detail-option'>
        <div className='detail-label'>MUNICIPIO</div>
        <div className='detail-value'>
          {(ApplicationsState.currentApplication.value
            ?.addressCity as string) ||
            ConvocatoriasState.currentConvocatoria.value?.name}
        </div>
      </div>
      <div className='detail-option'>
        <div className='detail-label'>TIPO DE SOLICITUD</div>
        <div className='detail-value'>{currentApplicationTypeLabel}</div>
      </div>
    </div>
  )
}
